import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=4c874cce&scoped=true&"
import script from "./licenses.vue?vue&type=script&lang=ts&"
export * from "./licenses.vue?vue&type=script&lang=ts&"
import style0 from "./licenses.vue?vue&type=style&index=0&id=4c874cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c874cce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
